var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogo512(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 496,
    height: 496,
    x: 8,
    y: 8,
    fill: "#6200ee",
    rx: 64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 256 L256 320 L504 256 L504 320 L256 384 L8 320 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 192 L8 72 Q8 8 72 8 L440 8 Q504 8 504 72 L504 192 L256 256 Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 496,
    height: 496,
    x: 8,
    y: 8,
    fill: "none",
    stroke: "#000",
    strokeWidth: 16,
    rx: 64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo512);
export default __webpack_public_path__ + "static/media/company-logo-512.78bfb5d28137b71f0e9711d731679712.svg";
export { ForwardRef as ReactComponent };